(() => {
  const STOCK_SELECTOR = '[data-mm-quick-buy-stock]';

  function hashString(str) {
    let hash = 2166136261;

    for (let i = 0; i < str.length; i++) {
      hash ^= str.charCodeAt(i);
      hash +=
        (hash << 1) +
        (hash << 4) +
        (hash << 7) +
        (hash << 8) +
        (hash << 24);
    }

    return Math.abs(hash >>> 0);
  }

  function getFakeStock(productId, variantId) {
    const key = `${productId}|${variantId}`;
    const hash = hashString(key);

    const options = [
      { type: 'low', qty: 1 },
      { type: 'low', qty: 1 },
      { type: 'low', qty: 1 },
      { type: 'low', qty: 1 },

      { type: 'low', qty: 2 },
      { type: 'low', qty: 2 },
      { type: 'low', qty: 2 },

      { type: 'low', qty: 3 },
      { type: 'low', qty: 3 },

      { type: 'low', qty: 4 },

      { type: 'good' },
      { type: 'good' }
    ];

    return options[hash % options.length];
  }

  function getForm(stockEl) {
    const formId = stockEl.dataset.formId;

    if (!formId) return null;

    return document.getElementById(formId);
  }

  function getVariantId(stockEl) {
    const form = getForm(stockEl);

    if (!form) return '';

    const variantInput = form.querySelector('[name="id"]');

    if (!variantInput || !variantInput.value) return '';

    return String(variantInput.value);
  }

  function renderStockElement(stockEl) {
    if (!stockEl) return;

    const productId = stockEl.dataset.productId || '';
    const variantId = getVariantId(stockEl);

    if (!productId || !variantId) return;

    const stock = getFakeStock(productId, variantId);

    stockEl.className = 'mm-quick-buy-stock';

    if (stock.type === 'good') {
      stockEl.classList.add('mm-stock-good');

      stockEl.innerHTML = `
        <span class="mm-stock-dot"></span>
        <span>In stock</span>
      `;

      return;
    }

    stockEl.classList.add('mm-stock-low');

    stockEl.innerHTML = `
      <span class="mm-stock-dot"></span>
      <span>Only ${stock.qty} ${stock.qty === 1 ? 'item' : 'items'} left in stock!</span>
    `;
  }

  function renderAllStock() {
    document.querySelectorAll(STOCK_SELECTOR).forEach(stockEl => {
      renderStockElement(stockEl);
    });
  }

  function scheduleRender() {
    setTimeout(renderAllStock, 50);
    setTimeout(renderAllStock, 150);
    setTimeout(renderAllStock, 350);
    setTimeout(renderAllStock, 700);
  }

  /*
   * Render when Quick Buy is opened.
   * Covers both desktop and mobile Quick Buy buttons.
   */
  document.addEventListener('click', event => {
    const quickBuyTrigger = event.target.closest(
      '[aria-controls*="quick-buy"], [aria-controls*="quick_buy"], .product-card__quick-buy, .product-card__quick-buy-button, .product-card__mobile-quick-buy-button'
    );

    if (quickBuyTrigger) {
      scheduleRender();
    }
  });

  /*
   * Render again whenever a Color or Size option is changed.
   */
  document.addEventListener('change', event => {
    if (
      event.target.closest(
        'variant-picker, quick-buy-drawer, .quick-buy-drawer'
      )
    ) {
      scheduleRender();
    }
  });

  /*
   * Some themes use labels/buttons instead of a native change event.
   */
  document.addEventListener('click', event => {
    const variantControl = event.target.closest(
      'variant-picker label, variant-picker button, variant-picker input'
    );

    if (variantControl) {
      scheduleRender();
    }
  });

  /*
   * Initial render in case Quick Buy content already exists.
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRender);
  } else {
    scheduleRender();
  }

  /*
   * Styling
   */
  const style = document.createElement('style');

  style.textContent = `
    .mm-quick-buy-stock {
      width: 100%;
      min-height: 20px;

      margin-top: 8px;
      margin-bottom: 16px;

      display: flex;
      align-items: center;
      justify-content: center;
      gap: 7px;

      text-align: center;
      font-size: 14px;
      line-height: 1.35;
      font-weight: 500;
    }

    .mm-quick-buy-stock .mm-stock-dot {
      width: 8px;
      height: 8px;

      display: inline-block;
      flex: 0 0 8px;

      border-radius: 50%;

      animation: mmQuickBuyPulse 1.2s infinite;
    }

    .mm-quick-buy-stock.mm-stock-low {
      color: #e60000;
    }

    .mm-quick-buy-stock.mm-stock-low .mm-stock-dot {
      background: #ff6b6b;
    }

    .mm-quick-buy-stock.mm-stock-good {
      color: #111;
    }

    .mm-quick-buy-stock.mm-stock-good .mm-stock-dot {
      background: #45b77a;
    }

    @media screen and (max-width: 749px) {
      .mm-quick-buy-stock {
        width: 100%;
        margin-top: 7px;
        margin-bottom: 15px;

        display: flex !important;
        align-items: center;
        justify-content: center;

        text-align: center;
        font-size: 13px;
      }
    }

    .mm-quick-buy-view-details {
  display: inline-block;
  width: fit-content;
  margin-top: 10px;
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}
    @keyframes mmQuickBuyPulse {
      0% {
        opacity: 1;
        transform: scale(1);
      }

      50% {
        opacity: 0.45;
        transform: scale(1.25);
      }

      100% {
        opacity: 1;
        transform: scale(1);
      }
    }
  `;

  document.head.appendChild(style);
})();
// Mobile quick-add highlight based on finger position
(() => {
  const MOBILE_MAX_WIDTH = 699;

  function activateCardAtPoint(x, y) {
    if (window.innerWidth > MOBILE_MAX_WIDTH) return;

    const cards = document.querySelectorAll('product-card');

    // Kijk welk element zich daadwerkelijk onder de vinger bevindt
    const touchedElement = document.elementFromPoint(x, y);
    const touchedCard = touchedElement
      ? touchedElement.closest('product-card')
      : null;

    // Vorige actieve product weer normaal maken
    cards.forEach((card) => {
      if (card !== touchedCard) {
        card.classList.remove('mm-mobile-active');
      }
    });

    // Alleen product onder de vinger activeren
    if (touchedCard) {
      touchedCard.classList.add('mm-mobile-active');
    }
  }

  document.addEventListener(
    'touchstart',
    (event) => {
      if (window.innerWidth > MOBILE_MAX_WIDTH) return;
      if (!event.touches.length) return;

      const touch = event.touches[0];
      activateCardAtPoint(touch.clientX, touch.clientY);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      if (window.innerWidth > MOBILE_MAX_WIDTH) return;
      if (!event.touches.length) return;

      const touch = event.touches[0];
      activateCardAtPoint(touch.clientX, touch.clientY);
    },
    { passive: true }
  );
})();
/* =========================================================
   MABEL & MARY — QUICK ADD COMPLETE FEEDBACK
   Reusable on every Quick Add
   ========================================================= */

(() => {

  let successTimer = null;


  /* ---------------------------------------------------------
     SUCCESS NOTICE
     --------------------------------------------------------- */

  function getSuccessNotice() {

    let notice =
      document.getElementById('mmQuickAddSuccess');

    if (notice) return notice;


    notice =
      document.createElement('div');

    notice.id =
      'mmQuickAddSuccess';

    notice.setAttribute(
      'role',
      'status'
    );

    notice.setAttribute(
      'aria-live',
      'polite'
    );

    notice.innerHTML = `
      <span
        class="mm-quick-add-success__check"
        aria-hidden="true"
      >
        ✓
      </span>

      <span
        class="mm-quick-add-success__text"
      >
        Added to Cart
      </span>
    `;

    document.body.appendChild(notice);

    return notice;
  }


  function showSuccess() {

    const notice =
      getSuccessNotice();

    clearTimeout(successTimer);

    notice.classList.remove(
      'is-visible'
    );

    void notice.offsetWidth;

    notice.classList.add(
      'is-visible'
    );

    successTimer =
      setTimeout(() => {

        notice.classList.remove(
          'is-visible'
        );

      }, 2400);
  }


  /* ---------------------------------------------------------
     SHOPIFY CART
     --------------------------------------------------------- */

  async function getCart() {

    try {

      const response =
        await fetch('/cart.js', {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          },
          cache: 'no-store'
        });

      if (!response.ok) {
        return null;
      }

      return await response.json();

    } catch (error) {

      console.error(
        'Quick Add cart request failed:',
        error
      );

      return null;
    }
  }


  /* ---------------------------------------------------------
     CART BADGE
     --------------------------------------------------------- */

  function updateCartBadge(itemCount) {

    const cartLink =
      document.querySelector(
        'a[aria-controls="cart-drawer"]'
      );

    if (!cartLink) return;


    const oldBadge =
      cartLink.querySelector(
        '.mm-header-cart-badge'
      );

    if (oldBadge) {
      oldBadge.style.display = 'none';
    }


    let badge =
      cartLink.querySelector(
        '.mm-quick-add-cart-count'
      );


    if (!badge && itemCount > 0) {

      badge =
        document.createElement('span');

      badge.className =
        'mm-quick-add-cart-count';

      cartLink.appendChild(badge);
    }


    if (!badge) return;


    if (itemCount <= 0) {
      badge.remove();
      return;
    }


    badge.textContent =
      itemCount;

    badge.classList.remove(
      'is-popping'
    );

    void badge.offsetWidth;

    badge.classList.add(
      'is-popping'
    );


    setTimeout(() => {

      if (badge.isConnected) {
        badge.classList.remove(
          'is-popping'
        );
      }

    }, 520);
  }


  /* ---------------------------------------------------------
     FIND CURRENT VISIBLE QUICK ADD
     --------------------------------------------------------- */

  function getCurrentQuickBuy(button) {

    /*
      First use the modal containing the
      button that was actually clicked.
    */

    const ownModal =
      button?.closest('quick-buy-drawer') ||
      button?.closest('quick-buy-modal') ||
      button?.closest('dialog') ||
      button?.closest('[role="dialog"]');

    if (ownModal) {
      return ownModal;
    }


    /*
      Otherwise find the currently visible
      Quick Add in the LIVE DOM.
    */

    const candidates =
      document.querySelectorAll(
        'quick-buy-drawer, quick-buy-modal, dialog, [role="dialog"]'
      );


    for (const element of candidates) {

      const rect =
        element.getBoundingClientRect();

      const style =
        window.getComputedStyle(element);

      if (
        rect.width > 0 &&
        rect.height > 0 &&
        style.display !== 'none' &&
        style.visibility !== 'hidden'
      ) {
        return element;
      }
    }


    return null;
  }


  /* ---------------------------------------------------------
     CLOSE CURRENT QUICK ADD
     --------------------------------------------------------- */

function closeQuickBuy(button) {

  const quickBuy =
    getCurrentQuickBuy(button);

  if (!quickBuy) {
    return;
  }

  /*
    Preferred method:
    use the theme's native QuickBuyDrawer.hide().
  */
  if (
    typeof quickBuy.hide ===
    'function'
  ) {

    quickBuy.hide();
    return;
  }


  /*
    Fallback only if this element does not
    expose the theme's native hide() method.
  */
  const closeButton =
    quickBuy.querySelector(
      '[is="close-button"]'
    ) ||
    quickBuy.querySelector(
      'button[aria-label="Close"]'
    ) ||
    quickBuy.querySelector(
      'button[aria-label="close"]'
    ) ||
    quickBuy.querySelector(
      '[data-action="close"]'
    ) ||
    quickBuy.querySelector(
      '.close-button'
    );


  if (closeButton) {

    closeButton.click();
    return;
  }


  if (
    typeof quickBuy.close ===
    'function'
  ) {

    quickBuy.close();
  }

}


  /* ---------------------------------------------------------
     WAIT FOR ACTUAL CART CHANGE
     --------------------------------------------------------- */

  async function waitForCartChange(
    previousCount
  ) {

    for (
      let attempt = 0;
      attempt < 10;
      attempt++
    ) {

      await new Promise(
        resolve =>
          setTimeout(resolve, 200)
      );


      const cart =
        await getCart();


      if (
        cart &&
        cart.item_count > previousCount
      ) {

        return cart;
      }
    }


    return null;
  }


  /* ---------------------------------------------------------
     QUICK ADD CLICK
     --------------------------------------------------------- */

  document.addEventListener(
    'click',
    async function (event) {

      const button =
        event.target.closest(
          'buy-buttons.mm-quick-buy-buttons button[type="submit"]'
        );


      if (
        !button ||
        button.disabled
      ) {
        return;
      }


      /*
        Prevent duplicate handling of the
        SAME physical click only.

        This lock belongs to this execution,
        not permanently to Shopify's modal.
      */

      if (
        button.dataset.mmQuickAddRunning ===
        'true'
      ) {
        return;
      }


      button.dataset.mmQuickAddRunning =
        'true';


      const text =
        button.querySelector(
          ':scope > div'
        );


      if (!text) {

        delete button.dataset
          .mmQuickAddRunning;

        return;
      }


      const originalText =
        text.textContent;


      /*
        Read cart before Shopify performs
        its normal Add to Cart.
      */

      const cartBefore =
        await getCart();


      const previousCount =
        cartBefore
          ? cartBefore.item_count
          : 0;


      text.textContent =
        'ADDING...';


      /*
        IMPORTANT:
        We do NOT prevent Shopify's click.
      */

      const changedCart =
        await waitForCartChange(
          previousCount
        );


      /*
        Always release our own lock.

        Crucially, this does NOT depend on
        document.contains(button).
      */

      delete button.dataset
        .mmQuickAddRunning;


      if (button.isConnected) {

        text.textContent =
          originalText;
      }


      /*
        No confirmed cart change = no
        fake success state.
      */

      if (!changedCart) {
        return;
      }


      updateCartBadge(
        changedCart.item_count
      );


      /*
        Close the CURRENT Quick Add.
      */

      closeQuickBuy(button);


      /*
        Show confirmation after the modal
        has started closing.
      */

      setTimeout(() => {

        showSuccess();

      }, 180);

    },
    true
  );

})();